import { ParametrosService } from './services/parametros.service';
import { ParametrosApi } from './api/Parametros.api';
import { SegmentoService } from './services/segmentos.service';
import { MunicipiosApi } from './api/municipios.api';
import { SolicitacoesCadastroClientesApi } from './api/solicitacoes-cadastro-clientes.api';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsersService } from './services/users.service';
import { PedidosService } from './services/pedidos.service';
import { ClientesService } from './services/clientes.service';
import { ProdutosService } from './services/produtos.service';
import { FiliaisService } from './services/filiais.service';
import { EstoqueService } from './services/estoque.service';
import { TabelasPrecoService } from './services/tabelas-preco.service';
import { CondicoesPagamentoService } from './services/condicoes-pagamento.service';
import { AvisosService } from './services/avisos.service';
import { GruposService } from './services/grupos.service';

import { UsersApi } from './api/users.api';
import { PedidosApi } from './api/pedidos.api';
import { ClientesApi } from './api/clientes.api';
import { ProdutosApi } from './api/produtos.api';
import { FiliaisApi } from './api/filiais.api';
import { EstoqueApi } from './api/estoque.api';
import { TabelasPrecoApi } from './api/tabelas-preco.api';
import { CondicoesPagamentoApi } from './api/condicoes-pagamento.api';
import { AvisosApi } from './api/avisos.api';
import { GruposApi } from './api/grupos.api';
import { PropostasService } from './services/propostas.service';
import { PropostasApi } from './api/propostas.api';
import { PropostaItemService } from './services/proposta-item.service';
import { SolicitacoesCadastroClientesService } from './services/solicitacoes-cadastro-clientes.service';
import { MunicipiosService } from './services/municipios.service';
import { SegmentoApi } from './api/segmento.api';
import { AprovadoresPedidoApi } from './api/aprovador-pedido.api';
import { AprovadorPedidoService } from './services/aprovador-pedido.service';
import { DashboardApi } from './api/dashboard.api';
import { DashboardService } from './services/dashboard.service';

const API = [
  UsersApi,
  PedidosApi,
  SolicitacoesCadastroClientesApi,
  PropostasApi,
  ClientesApi,
  ProdutosApi,
  FiliaisApi,
  EstoqueApi,
  TabelasPrecoApi,
  CondicoesPagamentoApi,
  ParametrosApi,
  AvisosApi,
  GruposApi,
  MunicipiosApi,
  SegmentoApi,
  AprovadoresPedidoApi,
  DashboardApi
];

const SERVICES = [
  UsersService,
  PedidosService,
  SolicitacoesCadastroClientesService,
  PropostasService,
  PropostaItemService,
  ClientesService,
  ParametrosService,
  ProdutosService,
  FiliaisService,
  EstoqueService,
  TabelasPrecoService,
  CondicoesPagamentoService,
  AvisosService,
  GruposService,
  MunicipiosService,
  SegmentoService,
  AprovadorPedidoService,
  DashboardService
];

@NgModule({
  imports: [CommonModule],
})
export class CommonBackendModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CommonBackendModule,
      providers: [
        ...API,
        ...SERVICES,
      ],
    };
  }
}
